import { useDispatch } from "react-redux";
import Button from "../../../../../UI/GeneralPurpose/Button";
import { UIactions } from "../../../../../../store/slices/UI";

const UIText = {
  "es-CL": { label: "Cancelar" },
  "en-US": { label: "Cancel" },
};

const Cancel = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(UIactions.closeModal());
  };

  return <Button {...{ UIText, onClick, variant:'outlined' }} />;
};

export default Cancel;
